import React from 'react';
import { jwtDecode } from 'jwt-decode';

import ListForInboxWorker from '../Components/ListsForInbox/ListForInboxWorker';

import Loading from '../Components/Loading';

const Inbox = () => {
  const [userRole, setUserRole] = React.useState('');
  
  React.useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      const decodedToken = jwtDecode(token);
      setUserRole(decodedToken.role);
    }
  }, []);

  return (
    <>
      {!userRole && <Loading />}
      {userRole=='Арбитражный управляющий' && <ListForInboxWorker />}
      {userRole=='Администратор' && <ListForInboxWorker />}
      {userRole=='Менеджер' && <ListForInboxWorker />}
      {userRole=='Работник по назначениям' && <ListForInboxWorker />}
      {userRole=='Арбитражный по жалобам' && <ListForInboxWorker />}
      {userRole=='Арбитражный по общим' && <ListForInboxWorker />}
    </>
  )
}

export default Inbox;